import type { StaticEntityType } from "@config";
import { DEFAULT_COMBO_SETTINGS } from "./default-combos-settings";

export const EMPTY_SIMPLE_COMBO = (
  element: StaticEntityType,
): StaticEntityType => ({
  id: "zlco4UL0m6Ugdo7",
  type: "combo",
  settings: DEFAULT_COMBO_SETTINGS.SIMPLE,
  children: [
    {
      id: "ofHoU4ls0QT05KA",
      type: "set",
      settings: {
        horizontalAlignment: "start",
        verticalAlignment: "center",
        groupsRatio: ["100", "100"],
      },
      children: [
        {
          id: "EpUQvjgAEyhGE5A",
          type: "group",
          settings: {},
          children: [element],
        },
      ],
    },
  ],
});
